import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { FooterComponent, NotifyComponent } from "@husbanken/designsystem-angular-core";
import { EnvironmentService } from "./shared/services/environment.service";
import { TestService } from "./shared/services/test.service";
import { AppHeaderComponent } from "./shared/components/header/header.component";
import { UserService } from "./shared/services/user.service";
import { VelgorganisasjonService } from "@husbanken/organisasjonsvelger-api";
import { Representation } from "@husbanken/designsystem-angular-header-v2";
import { UserRepresentsQuery } from "./shared/queries/user-represents.query";
import Keycloak from "keycloak-js";
import { TimeoutComponent } from "@husbanken/designsystem-angular-timeout";

const SPRAAK_COOKIE_KEY = "HbLanguage";
const DEFAULT_SPRAAK = "nb";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppHeaderComponent, RouterOutlet, NotifyComponent, FooterComponent, TimeoutComponent],
})
export class AppComponent {
  private userService = inject(UserService);
  private router = inject(Router);
  private translateService = inject(TranslateService);
  private velgOrgService = inject(VelgorganisasjonService);
  private keycloak = inject(Keycloak, { optional: true });
  private testService = inject(TestService);
  public userRepresentsQuery = inject(UserRepresentsQuery);
  public environmentService = inject(EnvironmentService);

  private valgtSprak = signal(localStorage.getItem(SPRAAK_COOKIE_KEY) ?? DEFAULT_SPRAAK);

  constructor() {
    this.translateService.use(this.valgtSprak());
    this.testService.checkAndEnableTestRunnerNavigation();
  }

  public changeLanguage(languageCode: string): void {
    this.valgtSprak.set(languageCode);
    this.translateService.use(languageCode);
    localStorage.setItem(SPRAAK_COOKIE_KEY, languageCode);
  }

  public changeRepresentation(representation: Representation): void {
    console.log(representation)
    if (!representation || this.userRepresentsQuery.getActive().organisasjonsnummer === representation.fodselOrgIdNr) {
      if (!representation) {
        this.router.navigateByUrl("/privat").then(s => {
          window.location.reload()
        })
        // this.keycloak.clearToken();
      }
      return;
    }

    if (this?.keycloak?.realm && this?.keycloak?.clientId) {
      this.velgOrgService.velgorganisasjon({ realm: this.keycloak.realm, clientId: this.keycloak.clientId, organisasjonsnummer: representation.fodselOrgIdNr }).subscribe(() => {
        // DEV-NOTE: Dette er ikke en optimal løsning. Ideelt sett ønsker vi å bare refreshe data i applikasjonen og ikke laste hele app'en på nytt.
        // this.keycloak.clearToken();
        this.router.navigateByUrl("/proff").then(s => {
          this.keycloak.clearToken();
        });
      });
    }
  }

  public logout(): void {
    this.userService.logout();
  }
}
